"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HackersRebalanced = void 0;
var Card_1 = require("../../Card");
var CardType_1 = require("../../CardType");
var Resources_1 = require("../../../Resources");
var CardName_1 = require("../../../CardName");
var CardRenderer_1 = require("../../render/CardRenderer");
var Units_1 = require("../../../Units");
var HackersRebalanced = (function (_super) {
    __extends(HackersRebalanced, _super);
    function HackersRebalanced() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.HACKERS_REBALANCED,
            cost: 3,
            metadata: {
                cardNumber: '125',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) {
                        pb.minus().energy(1).megacredits(1).any.br;
                        pb.plus().megacredits(3);
                    });
                }),
                description: 'Decrease your energy production 1 step and EACH OPPONENTS M€ production 1 step. Increase your M€ production 3 steps.',
                victoryPoints: -1,
            },
        }) || this;
    }
    HackersRebalanced.prototype.canPlay = function (player) {
        return player.getProduction(Resources_1.Resources.ENERGY) >= 1;
    };
    HackersRebalanced.prototype.play = function (player) {
        var opponents = player.game.getPlayers().filter(function (p) { return p.id !== player.id && p.canAdjustProduction(Units_1.Units.of({ megacredits: -1 })); });
        opponents.forEach(function (p) {
            p.adjustProduction(Units_1.Units.of({ megacredits: -1 }), { log: true, from: player });
            return undefined;
        });
        player.addProduction(Resources_1.Resources.MEGACREDITS, 3);
        player.addProduction(Resources_1.Resources.ENERGY, -1);
        return undefined;
    };
    HackersRebalanced.prototype.getVictoryPoints = function () {
        return -1;
    };
    return HackersRebalanced;
}(Card_1.Card));
exports.HackersRebalanced = HackersRebalanced;
//# sourceMappingURL=HackersRebalanced.js.map